var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 15,
    viewBox: "0 0 49 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7071 8.07112C49.0976 7.6806 49.0976 7.04743 48.7071 6.65691L42.3431 0.292946C41.9526 -0.0975785 41.3195 -0.0975785 40.9289 0.292946C40.5384 0.68347 40.5384 1.31664 40.9289 1.70716L46.5858 7.36401L40.9289 13.0209C40.5384 13.4114 40.5384 14.0446 40.9289 14.4351C41.3195 14.8256 41.9526 14.8256 42.3431 14.4351L48.7071 8.07112ZM0 7.36401V8.36401H48V7.36401V6.36401H0V7.36401Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowB);
export default __webpack_public_path__ + "static/media/Arrow_B.ba939b7c1bb9a377c0f16722b703fa49.svg";
export { ForwardRef as ReactComponent };